import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { TransactionRequestEtisalatInputParamsModel, TransactionRequestPayWCreditCardInputParamsModel } from 'src/app/card-operations-core/models/transaction-request-models';
import { product, productsServiceResModel } from 'src/app/card-operations/models/getProductsResponse.model';
import { IFirstStepComplete, ISelectedChargeInfo } from 'src/app/card-operations/models/paymenType.model';
import { AliasService } from 'src/app/card-operations/services/alias.service';
import { ProductService } from 'src/app/card-operations/services/getProducts.service';
import { AppConfig } from 'src/app/config-service/app.config';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { BalanceService } from 'src/app/home/services/cardBalance.service';
import { IOnlineChargeMediator, OnlineChargeBaseComponent, OnlineChargeMediator } from '../utility-classes/online-charge-classes';
import { AliasControlLuhnStrategy, IAliasControlStrategy } from './utility-classes/alias-controller';
import { ValidateAmount } from './utility-classes/payment-amount-validators';

@Component({
  selector: 'app-first-step',
  templateUrl: './firs-step.component.html',
  styleUrls: ['./firs-step.component.scss', '../../../card-operations.component.css']
})
export class FirstStepComponent extends OnlineChargeBaseComponent implements OnInit {
  @Input() modalType!: string;
  @Input() modalInput!: string;
  @Input() concreteMediator!: IOnlineChargeMediator;

  apiSettings = AppConfig.settings;
  // readonly aliasController: IAliasControlStrategy = new AliasControlLuhnStrategy();
  
  forms = new FormGroup({
    amountForm : new FormControl('', [Validators.required])
  });

  aliasNoControlWarningLabel = '';
  queryAlias = '';
  selectedCardProductCode = '0';
  selectedChargeAmountType = 0;
  selectedChargeAmount = 0;
  selectedChargeCommissionAmount = 0;
  selectedChargeTotalAmount = 0;
  productResult!: productsServiceResModel | null;
  productsArray: Array<product> = [];
  private cardAlias:string = '';
  isLoading = false;
  isProductsReceived:boolean = false;
  private product!:product;
  balanceResult = '0';

  public creditCardparams!: TransactionRequestPayWCreditCardInputParamsModel;
  public etisalatRequiredParams!: TransactionRequestEtisalatInputParamsModel;

  constructor(
    private toastr: ToastrService,
    public translate: TranslateService,
    public activeModal: NgbActiveModal,
    public restGetProducts: ProductService,
    public restGetBalance: BalanceService,
    protected mediator: OnlineChargeMediator,
    private aliasService: AliasService
  ) { 
    super(mediator);
  }

  ngOnInit(): void {
    this.setMediator(this.concreteMediator);

    if(!!this.modalInput){
      this.queryAlias = this.modalInput;
      this.onChangeQueryAliasNo(this.queryAlias);
    }

    this.forms.controls['amountForm'].valueChanges.subscribe(value => {
      this.selectedChargeAmount = value;
    });
  }

  onlineCharge_onNextClick = () => {
    if(this.amountErrors.valid){
      const product:product = this.findProduct(
        this.selectedCardProductCode, 
        this.productResult!.InventoryArray
      )!;

      const message = this.calculateAllAmountsAndEmit(product, 1, this.selectedChargeAmount);

      if (!this.aliasService.aliasControl(this.queryAlias)) {
        this.aliasNoControlWarningLabel = 'Please enter your card number correctly';
      } else {
        this.mediator.notifyOnlineCharge(this, 'AMOUNT_SELECTED', message);
      }
    }
  };

  onChangeQueryAliasNo = (text:any) => {
    this.isProductsReceived = false;

    this.queryAlias = this.aliasService.formatAlias(this.queryAlias, text);
    this.cardAlias = this.queryAlias.split('-').join('').slice(0, -1);

    this.selectedCardProductCode = '0';

    if (this.modalType === 'AddtoFav') {
      return;
    }

    if(this.aliasService.aliasControl(this.queryAlias)){
      this.aliasNoControlWarningLabel = '';
      this.isLoading = true;
      new Promise((resolve, reject) => {
        let alias = this.aliasService.reformatAlias(this.queryAlias);

        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            if (resp.result.code !== 0) {
              this.aliasNoControlWarningLabel = 'Giriş Yapınız!';
              this.activeModal.dismiss('Cross click');
            } else if (resp.result.code == 0) {
              resp.cardlist.forEach((el:cardDetailResModel) => {
                localStorage.setItem('card-type', el.cardType)
                this.isLoading = false;
                this.balanceResult = el.balance;
                this.selectedCardProductCode = el.product_code;
                this.getProductsAndValidate(el.product_code);
              });
            } else {
              this.isLoading = false;
              this.aliasNoControlWarningLabel = resp.result.message;
            }
          },
          (error:unknown) => {
            this.isLoading = false;
            reject(error);
          }
        );
      });
    } else {
      if (this.queryAlias.length > 5) {
        this.aliasNoControlWarningLabel = 'Kart numaranızı eksiksiz giriniz';
      }
    }
  };

  private calculateAllAmountsAndEmit = (
    product:product, 
    selectedChargeAmountType: number, 
    selectedChargeAmount:number
  ) : IFirstStepComplete => {
    let transactionCommission = this.selectedChargeAmount * product.commission['24'].commissionRate +
      product.commission['24'].commissionPerTransaction;
    
    if (transactionCommission > product.commission['24'].maxCommissionAmount) {
      transactionCommission = product.commission['24'].maxCommissionAmount;
    }

    const selectedChargeCommissionAmount = transactionCommission;
    const selectedChargeTotalAmount = selectedChargeAmount + selectedChargeCommissionAmount;

    const amountParameters = {
      selectedChargeAmount: selectedChargeAmount,
      selectedChargeTotalAmount: selectedChargeTotalAmount, 
      selectedChargeAmountType: selectedChargeAmountType,
      selectedChargeCommissionAmount: selectedChargeCommissionAmount,
      queryAlias: this.queryAlias,
      product_code: product.product_code,
      cardAlias: this.cardAlias,
      product_type: product.process_type,
      media_type: product.media_type,
      price: JSON.stringify(product.price)
    };

    return amountParameters;
  }

  findProduct(selectedCardProductCode:string, inventoryArray:product[]): product | undefined {
    for (let i = 0; i < inventoryArray.length; i += 1) {
      if (selectedCardProductCode === inventoryArray[i].product_code){
        return inventoryArray[i];
      }
    }

    return undefined;
  }
  
  private getProductsAndValidate(selectedCardProductCode:string) {
    this.isLoading = true;
    this.restGetProducts.getProductResult()
    .pipe(
      tap((response:any) => {
        localStorage.setItem('productArr', JSON.stringify(response));
        this.productResult = JSON.parse(JSON.stringify(response) || '[]');
        
        this.product = this.findProduct(selectedCardProductCode, this.productResult!.InventoryArray)!
      }),
      tap((response:any) => {
        const max_amount = this.product.price.max_charge_amount;
        const min_amount = this.product.price.min_charge_amount;
        this.forms.controls['amountForm'].addValidators([ValidateAmount(min_amount, max_amount)]);
      })
    )
    .subscribe(
      (resp:any) => {
        this.isLoading = false;
        this.isProductsReceived = true;
      },
      (error:unknown) => {
        this.isLoading = false;
      }
    );
  }

  get amountErrors(){
    return this.forms.controls["amountForm"];
  }

  get invalidAmountError(){
    if(!!this.forms.controls["amountForm"].errors!.amountInvalid){
      return this.forms.controls["amountForm"].errors!.amountInvalid.error
    };
  }

}